// extracted by css-extract-rspack-plugin
export default {"followBasicInfoBox":"followBasicInfoBox-ralzZT","followBox":"followBox-X7sY8P","followTime":"followTime-QonH0V","followMain":"followMain-OdgWu1"};